import {
  DESIGN_ASSET_UNAVAILABLE_MESSAGE,
  DESIGN_COLOR_SUPPLY_UNAVAILABLE_MESSAGE,
  DESIGN_COLOR_UNAVAILABLE_MESSAGE,
  DESIGN_COMPONENT_UNKNOWN_MESSAGE,
  DESIGN_FONT_NOT_ALLOWED_MESSAGE,
  DESIGN_INK_COLOR_NOT_ALLOWED_MESSAGE,
  DESIGN_PRODUCT_DISCONTINUED_MESSAGE,
  DESIGN_PRODUCT_HIDDEN_MESSAGE,
  DESIGN_SAVE_CONFLICT_MESSAGE,
} from '@repo/api-contracts';

export type SaveErrorKind =
  | 'font'
  | 'ink'
  | 'asset'
  | 'component'
  | 'color'
  | 'product'
  | 'conflict'
  /** 이메일 인증·본인인증을 마치지 않은 계정 — 온보딩으로 안내한다. */
  | 'identity'
  /** 저장 전 계약 검사 실패(빈 텍스트·범위 밖 값). ids 는 맨 위 레이어 id. */
  | 'invalid'
  | 'unauthorized'
  | 'unknown';

export interface SaveErrorInfo {
  readonly kind: SaveErrorKind;
  readonly ids: readonly string[];
  readonly message: string;
}

interface SaveErrorLike {
  readonly message: string;
  readonly data?: { readonly code?: string } | null;
}

const LIST_MESSAGES: readonly [string, SaveErrorKind][] = [
  [DESIGN_FONT_NOT_ALLOWED_MESSAGE, 'font'],
  [DESIGN_INK_COLOR_NOT_ALLOWED_MESSAGE, 'ink'],
  [DESIGN_ASSET_UNAVAILABLE_MESSAGE, 'asset'],
  [DESIGN_COMPONENT_UNKNOWN_MESSAGE, 'component'],
];
const EXACT_MESSAGES: readonly [string, SaveErrorKind][] = [
  [DESIGN_COLOR_UNAVAILABLE_MESSAGE, 'color'],
  [DESIGN_COLOR_SUPPLY_UNAVAILABLE_MESSAGE, 'color'],
  [DESIGN_PRODUCT_DISCONTINUED_MESSAGE, 'product'],
  [DESIGN_PRODUCT_HIDDEN_MESSAGE, 'product'],
  [DESIGN_SAVE_CONFLICT_MESSAGE, 'conflict'],
  // 인증 전 계정(activeProcedure 거절) — 이메일 인증·본인인증 둘 다 온보딩으로 보낸다.
  ['이메일 인증이 필요합니다.', 'identity'],
  ['본인인증이 필요합니다.', 'identity'],
];

/** 저장 거부를 종류와 id 로 가른다(로드맵 Phase 7 "Phase 6 API 제약"). 목록형 400 은 앞부분으로 대조한다. */
export const describeSaveError = (error: SaveErrorLike): SaveErrorInfo => {
  for (const [prefix, kind] of LIST_MESSAGES) {
    if (error.message.startsWith(prefix)) {
      const rest = error.message.slice(prefix.length).replace(/^:\s*/, '');
      return {
        kind,
        ids: rest.length === 0 ? [] : rest.split(',').map((id) => id.trim()),
        message: prefix,
      };
    }
  }
  for (const [exact, kind] of EXACT_MESSAGES)
    if (error.message === exact) return { kind, ids: [], message: exact };
  if (error.data?.code === 'UNAUTHORIZED')
    return { kind: 'unauthorized', ids: [], message: error.message };
  return { kind: 'unknown', ids: [], message: '저장하지 못했습니다. 잠시 뒤 다시 시도해 주세요.' };
};
